var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrders(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6 23H5.4a3 3 0 0 1-2.98-3.37l1.25-10A3.01 3.01 0 0 1 6.65 7H7v3a1 1 0 0 0 2 0V7h6v3a1 1 0 0 0 2 0V7h.35a3.01 3.01 0 0 1 2.98 2.63l1.25 10A3 3 0 0 1 18.6 23ZM17 5h-2a3 3 0 0 0-6 0H7a5 5 0 0 1 10 0Z",
    fill: "#999999",
    className: "fill-232323"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrders);
export default __webpack_public_path__ + "static/media/Orders.511e7982f16825c73fd7b6720015c5b5.svg";
export { ForwardRef as ReactComponent };